import type { ConvertedFormUnsubNLDataType } from '../../GeneralForm/helpers/handleSubmit';
import { InputIDs } from '../../types';

export const convertFormDataToPostData = (
  areaKey: string,
  data: { frequency: string; email: any; pause?: string },
): ConvertedFormUnsubNLDataType => {
  // radio values are strings with pattern "type|value"
  const [frequencyType, frequencyValue] =
    (data[InputIDs.FREQUENCY] && data[InputIDs.FREQUENCY].split('|')) || [];

  let typeValue = Number(frequencyValue);

  // PAUSE NEWSLETTER: If selected, set the pause value as typeValue
  if (frequencyType === 'pause') {
    typeValue = Number(data[InputIDs.PAUSE]);
  }
  return {
    emailAddress: data[InputIDs.EMAIL] || '',
    type: frequencyType,
    typeValue,
    areaKey,
  };
};
